import { RegulacionPlazaModel } from './regulacion-plaza.model';
import { UsoPlazaModel } from './uso-plaza.model';

export class RegulacionPlazaInformePlanoModel {

    regulacionPlaza: RegulacionPlazaModel;
    usoPlaza: UsoPlazaModel;
}
